export default __webpack_public_path__ + "static/media/tete43.8f1f047e.png";